import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
//import TimePicker from 'react-time-picker';
import ManageInvestor from '../../services/manageInvestor';
import Utils from "../../utils/utils"

export default class AddIntermediary extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false, 
      moreEmails: ''
    }

    this.grid = 2;

    this.pageTitle = "Add Investor";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {

    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const intermediaryType = cookies.get('intermediaryType', { path: '/' });

    this.setState({});
  }

  render () {

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'username', numeric: false, disablePadding: true, label: 'Username' },
      { id: 'name', numeric: true, disablePadding: false, label: 'Name' },
      { id: 'surname', numeric: true, disablePadding: false, label: 'Surname' },
    ];

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />
          <TextInput name={'Investor name'} value={this.state.investorName} 
            onChange={(text) => { this.setState({investorName: text})}
          } />
          <TextInput name={'Company'} value={this.state.company} 
            onChange={(text) => { this.setState({company: text})}
          } />
          <TextInput name={'Country'} value={this.state.country} 
            onChange={(text) => { this.setState({country: text})}
          } />
          <TextInput name={'Phone number'} value={this.state.phoneNumber} 
            onChange={(text) => { this.setState({phoneNumber: text})}
          } />
          <TextInput name={'Mobile number'} value={this.state.mobileNumber} 
            onChange={(text) => { this.setState({mobileNumber: text})}
          } />
          <TextInput name={'Email address'} value={this.state.email} 
            onChange={(text) => { this.setState({email: text})}
          } />
          <TextInput name={'Additional e-mail address'} value={this.state.additionalMailAddress} 
            onChange={(text) => { this.setState({additionalMailAddress: text})}
          } />
           <TextInput name={'Other e-mail addresses (separated by ;)'} value={this.state.moreEmails} 
            onChange={(text) => { this.setState({moreEmails: text})}
          } />

          <FixButton title={'Save'} callback={this.save.bind(this)} />

        </LoadingOverlay>
      </>
    );
  }

  async save (){
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });
      const currentEventId = cookies.get('currentEventId', { path: '/' });
      const currentBroker = cookies.get('currentBroker', { path: '/' });

      const country = this.state.country;
      const phone_number = this.state.phoneNumber;
      const mobile_number = this.state.mobileNumber;
      const email_address = this.state.email;
      const pdf_profile = this.state.pdf_profile;
      const second_email_address = this.state.additionalMailAddress;

      if (this.state.email != undefined && this.state.email != '' && Utils.validateEmail(this.state.email) == false){
        alert('Check the email address');
        return;
      }

      if (this.state.additionalMailAddress != undefined && this.state.additionalMailAddress != '' && Utils.validateEmail(this.state.additionalMailAddress) == false){
        alert('Check the additional email address');
        return;
      }

      let emails = this.state.moreEmails;
      if (emails) {
        var validated = true;
        emails.split(';').forEach(mail => {
          if (!mail || !Utils.validateEmail(mail)) {
            alert('There\'s an error with the email address: ' + mail);
            validated = false;
          }
        });
        if (!validated) {
          return;
        }
      }

      let res = await ManageInvestor (username, token, '', currentEventId, currentBroker, 
                                    this.state.investorName, this.state.company, 
                                    country, phone_number, mobile_number, email_address, 
                                    pdf_profile, second_email_address, this.state.moreEmails, false, 0);
      if (res.result != 'ok'){
        alert ('An error occurred while creating a new intermediary.')
      } else {
        window.location.href = '/#/app/investors';
      }
  }

}

